import React from 'react'
import './Footer.css'
import wave from '../../images/wave.png'

const Footer = () => {
  return (
    <div>
      <div className="footer">
      <a href="https://gari.network/" target="_blank" rel="noopener noreferrer">
      <img src='https://gari.network/wp-content/uploads/2021/11/gari-logo-1.svg' alt="" style={{width:'70%',marginLeft:"13%"}}/>
      </a>
      <br />
      <span >Ⓒ Copyright © 2018 - 2023 Tech4Billion Media Private Limited. All Rights Reserved.</span>
      </div>
    </div>
  )
}

export default Footer
